import './ScrollingCardsDays.scss'

import DayCard from 'components/courses/DayCard'

/**
 * ScrollingCards component. Used to display horizontally scrolling card component
 */
export default function ScrollingCardsDays({
  title,
  lessons,
  returnPath = null,
  emptyText = 'Nothing here yet'
}) {
  return (
    <>
      {title && <h3>{title}</h3>}
      <div className='scrolling-card-day-wrapper'>
        <div className='scrolling-card-day-cards'>
          {lessons && lessons.length > 0 ? (
            lessons.map((lesson, i) => (
              <DayCard
                key={lesson.id || lesson.ID}
                lesson={lesson}
                style={{ animationDelay: `${0.05 * i}s` }}
                returnPath={returnPath}
              />
            ))
          ) : (
            <div className='no-cards'>
              <p>{emptyText}</p>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
